<!--
   Created by qing on 2021/7/20
   Des: 表单详情评论
-->
<template>
  <div class="form-comment-btn-container">

    <van-popup
      class="comment-input-popup"
      v-model="showCommentInput"
      :style="{ height: '80%', width: '100%' }"
      position="bottom"
      get-container="body"
      @close="inputClose">
      <div style="display: flex; justify-content: flex-end; padding: 0 20px; height: 40px; align-items: center">
        <van-icon name="close" style="cursor: pointer" @click="onClickClose" />
      </div>
      <div class="comment-submit-container" v-if="showCommentInput && commentInfo">

        <div class="reply-container" v-if="commentStatus === 'REPLY'">
          <div class="line"></div>
          <div class="reply-content">
            回复&nbsp;&nbsp;{{replyCommentInfo.userName}}:&nbsp;{{fetchSourceContent(replyCommentInfo.commentId)}}
          </div>
        </div>

        <FormulaEditor
          :value.sync="commentInfo.content"
          placeholder="请输入评论内容..."
          @ready="editorReady"
          @textChange="commentChange"
          ref="formulaEditor">
        </FormulaEditor>

        <ul class="file__list">
          <li v-for="(file, idx) in commentInfo.attachmentList">
            <div class="file__icon" v-if="!file.fileType.includes('image')">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
              </svg>
            </div>
            <div v-if="file.fileType.includes('image')" class="file__img">
              <img :src="file.fileUrl" alt="">
            </div>
            <div class="file__info">
              <div class="file__info-name">
                {{file.fileName}}
              </div>

              <div class="file__info-bottom">

                <div class="file__info-size">
                  {{file.fileSize}}KB
                </div>
                <div class="file__info-handle">
                  <i
                    v-if="file.fileType.includes('image')"
                    class="el-icon-zoom-in"
                    @click.stop.prevent.left="downloadFile(file)"
                  ></i>
                  <i
                    class="el-icon-download"
                    @click.stop.prevent.left="downloadFile(file)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    style="color: red; margin-left: 10px;"
                    @click.stop.prevent.left="commentInfo.attachmentList.splice(idx, 1)"
                  ></i>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div class="handle" :style="{justifyContent: 'flex-end'}">
          <div>
            <el-button
              type="text"
              icon="el-icon-paperclip"
              @click.stop.prevent.left="selectFile"
            ></el-button>
            <el-button
              size="mini"
              type="success"
              @click.stop.prevent.left="submitComment">
              评论
            </el-button>
          </div>
        </div>
      </div>

      <!--@人-->
      <ContactBox
        key="AtContactBox"
        fieldId="AtContactBox"
        ref="contactBox"
        :showTag="false"
        :field="atUserConfig"
        :user-id="$store.state.userId"
        :company-id="$store.state.companyId"
        :hasDep="false"
        :hasRole="false"
        :has-label="false"
        :has-current="false"
        :multiple="true"
        :selectedMember="[]"
        :selectedExt="[]"
        @selectedComplete="selectedComplete">
      </ContactBox>
    </van-popup>
    <div class="comment-btn">
      <el-input readonly placeholder="发表评论..." @focus="focusComment"></el-input>
    </div>
  </div>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage, getSimpleText, clone, arrayRemove} from "../../assets/js/Untis";
  import {uuid} from "../RyForm/utils";
  import FormulaEditor from "./FormulaEditor";

  const comment = {
    instanceId: '',
    commentLocation: '', // 评论的位置 view 视图 DATA 管理数据 FLOW 流程
    viewId: '',
    stepId: '',
    atUserList: [],
    commentType: '',
    rootId: '',
    replyId: '',
    content: "",
    attachmentList: []
  }
  export default {
    props: {
      instanceId: {
        type: String,
        default: ''
      },
      // 评论的位置 view 视图 DATA 管理数据 FLOW 流程
      commentLocation: {
        type: String,
        default: 'DATA'
      },
      viewId: {
        type: String,
        default: ''
      },
      stepId: {
        type: String,
        default: ''
      },
      // NODE 目录 ITEM 挂载 INSTANCE 表单
      commentType: {
        type: String,
        default: 'NODE'
      },
      fetchSourceContent: Function,
      atUserConfig: Object
    },
    data() {
      return {
        showCommentInput: false,
        commentStatus: 'NONE', // NONE 首次发表评论、 REPLY 回复评论、 EDIT 编辑评论
        commentInfo: null,
        replyCommentInfo: null,

        downloadEle: null,
        fileInput: null,
        showLoading: false,
      }
    },
    components: {
      FormulaEditor
    },
    created() {

      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')

      this.fileInput = document.createElement('input')
      this.fileInput.setAttribute('type', 'file')
      this.fileInput.onchange = this.fileChange
    },
    mounted() {
      // 设置 CodeMirror 必须设置项
      CodeMirror.keywords = []
      CodeMirror.fields = {}
      Object.keys(this.$store.getters.userListMap).forEach(userId => {
        const user = this.$store.getters.userListMap[userId]
        CodeMirror.fields[userId] = {
          envVarName: userId,
          fieldTitle: user.nickname,
        }
      })
    },
    watch: {
      showCommentInput() {
        if (!this.showCommentInput) {
          this.inputClose()
        }
      }
    },
    methods: {
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },

      open({commentStatus, commentInfo, replyCommentInfo}) {
        this.commentStatus = commentStatus
        this.replyCommentInfo = replyCommentInfo || {}
        if (commentStatus === 'EDIT') {
          this.commentInfo = commentInfo ? clone(commentInfo) : clone(comment)
        }
        if (!this.commentInfo){
          this.commentInfo = commentInfo ? clone(commentInfo) : clone(comment)
        }
        this.showCommentInput = true
      },
      inputClose() {
        if (this.commentStatus === 'EDIT') {
          this.commentInfo = null
        }
      },
      onClickClose() {
        this.showCommentInput = false
        this.inputClose()
      },
      // 首次填写评论
      focusComment() {
        this.$emit('focusComment')
      },

      selectFile() {
        this.fileInput.click()
      },

      fileChange(e) {
        const mimeTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
        const file = e.target.files[0]
        const fileInfo = {
          fileName: file.name,
          fileSize: (file.size / 1000).toFixed(2),
          fileUrl: '',
          fileType: file.type ? (mimeTypes.includes(file.type) ? 'xls' : file.type) : file.name.split('.').slice(-1)[0],
          id: uuid('FILE')
        }
        this.showLoading = true
        this.$RyFs.upload(e.target.files)
          .then(res => {
            fileInfo.fileUrl = res[0]
            this.commentInfo.attachmentList.push(fileInfo)
          })
          .catch(err => {
            this.$toast.fail('上传失败')
            console.error(err)
          })
          .finally(() => {
            this.fileInput.value = ''
            this.showLoading = false
          })
      },

      // 下载文件
      downloadFile(file) {
        this.downloadEle.setAttribute('download', file.fileName)
        this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.state.userInfo.userId}`)
        this.downloadEle.click()
      },
      // 发表评论
      submitComment() {
        console.log(this.commentInfo)
        if (!this.commentInfo.content && !this.commentInfo.attachmentList.length) {
          this.$toast.fail('评论内容或附件不能为空')
          return
        }
        const loading = this.$toast.loading()
        this.commentInfo.commentType = this.commentType

        if (this.commentStatus === 'EDIT') {
          this.$store.dispatch('actionCommentUpdate', {
            ...this.commentInfo
          }).then(res => {
            this.$emit('submitCommentComplete', {
              commentStatus: this.commentStatus,
              commentInfo: clone(this.commentInfo)
            })
            this.commentInfo = null
            this.$toast.success('更新成功')
            this.showCommentInput = false
          }).catch(console.error)
            .finally(() => {
              loading.clear()
            })

        } else {

          this.commentInfo.instanceId = this.instanceId
          this.commentInfo.commentLocation = this.commentLocation
          this.commentInfo.viewId = this.viewId
          this.commentInfo.stepId = this.stepId
          if (this.commentStatus === 'REPLY') {
            this.commentInfo.rootId = this.replyCommentInfo.rootId
            this.commentInfo.replyId = this.replyCommentInfo.commentId
          }
          this.$store.dispatch('actionFormCommentAdd', {
            ...this.commentInfo
          }).then(res => {
            this.$emit('submitCommentComplete', {
              commentStatus: this.commentStatus,
              commentInfo: res
            })
            this.commentInfo = null
            this.$toast.success('评论成功')
            this.showCommentInput = false
          }).catch(console.error)
            .finally(() => {
              loading.close()
            })
        }
      },

      editorReady() {
        console.log('editorReady')

        const codemirror = this.$refs.formulaEditor.cmInstance
        const fields = CodeMirror.fields
        const varList = Object.keys(fields)
        // 是用正则匹配变量 将变量 id 替换为 mark

        const snsArr = this.commentInfo.content.split(/\n/g)
        snsArr.forEach((str, index) => {
          str.replace(new RegExp(`\\$(${varList.join('|')})\\$`, "ig"), (fieldTxt, fieldId, idx) => {
            const form = {line: index, ch: idx}
            const to = {line: index, ch: idx + fieldTxt.length}
            const field = fields[fieldId]
            const ele = document.createElement('span')
            ele.setAttribute('class', `cm-mark-text cm-mark-value cm-mark-user`)
            ele.innerText = `@${field.fieldTitle}`
            codemirror.markText(form, to, {
              handleMouseEvents: true,
              atomic: true,
              replacedWith: ele
            })
          })
        })

        setTimeout(() => {
          codemirror.focus();
          codemirror.setCursor(codemirror.lineCount(), 0);
        },300)
      },

      // 字段被点击时
      fieldItemClick(field) {
        const codemirror = this.$refs.formulaEditor.cmInstance
        const pos = codemirror.getCursor()
        const envId = `$${field.envVarName}$`

        codemirror.replaceSelection(envId)
        console.log('field',field)
        //**
        const ele = document.createElement('span')
        ele.setAttribute('class', `cm-mark-text cm-mark-value cm-mark-user`)
        ele.innerText = `@${field.fieldTitle}`
        const form = pos
        const to = {line: pos.line, ch: pos.ch + envId.length}
        codemirror.focus()
        codemirror.setCursor({
          line: pos.line,
          ch: pos.ch + envId.length + 2
        })
        codemirror.markText(form, to, {
          handleMouseEvents: true,
          atomic: true,
          replacedWith: ele
        })
        console.log('commentInfo',this.commentInfo.content)
      },
      commentChange(changeObj) {
        console.log('commentChange',changeObj, this.commentInfo.content)
        if (changeObj.text[0] === '@') {
          this.commentInfo.content = this.commentInfo.content.substr(0, this.commentInfo.content.length - 1);
          this.$refs.formulaEditor.cmInstance.setSelection(
            {line:changeObj.from.line,ch:changeObj.from.ch},
            {line:changeObj.from.line,ch:changeObj.from.ch + 1})
          this.$refs.formulaEditor.cmInstance.replaceSelection('')
          if (this.$refs.contactBox) {
            this.$refs.contactBox.open()
            this.showCommentInput = false
          }
        } else if (changeObj.removed.length && changeObj.removed[0]) {
          const fields = CodeMirror.fields
          const varList = Object.keys(fields)
          changeObj.removed[0].replace(new RegExp(`\\$(${varList.join('|')})\\$`, "ig"), (fieldTxt, fieldId, idx) => {
            console.log('fieldId', fieldId)
            arrayRemove(this.commentInfo.atUserList, Number(fieldId))
            console.log('arrayRemove', this.commentInfo.atUserList)
          })
        }
      },

      selectedComplete(val) {
        // this.current.value.member = selected.memberIds
        // this.current.value.depart = selected.depIds
        // this.current.value.external = selected.extIds
        // this.current.value.externalTag = selected.labelIds
        this.showCommentInput = true
        setTimeout(() => {
          val.memberIds.forEach(userId => {
            if (!this.commentInfo.atUserList.includes(userId)) {
              console.log('selectUserComplete',val, userId)
              const user = this.$store.getters.userListMap[userId]
              this.fieldItemClick({
                envVarName: userId,
                fieldTitle: user.nickname,
              })
              this.commentInfo.atUserList.push(userId)
            }
          })
          val.extIds.forEach(userId => {
            if (!this.commentInfo.atUserList.includes(userId)) {
              console.log('selectUserComplete',val, userId)
              const user = this.$store.getters.extMap[userId]
              this.fieldItemClick({
                envVarName: userId,
                fieldTitle: user.orgUserName,
              })
              this.commentInfo.atUserList.push(userId)
            }
          })
          console.log('atUserList',this.commentInfo.atUserList)
          this.editorReady()
        },500)
      },
    }
  }
</script>

<style lang="less">

  .form-comment-btn-container {
    background: #f7f7f7;
    width: 100%;
    padding: 12px;
    box-shadow: 0 -2px 5px rgba(0,0,0,.1);
    position: absolute;
    bottom: 0;
    left: 0;
    max-height: 480px;
    overflow: auto;

    .comment-btn {
      width: 100%;
      overflow-y: auto;
      position: relative;
      border-radius: 2px;
    }

    .ry-contacts__box {
      min-height: 0;
      line-height: 0;
      height: 0;
    }
  }

  .comment-input-popup {

    .comment-submit-container {
      position: relative;
      width: 100%;
      height: calc(100% - 45px);

      .formula-editor {
        margin: 5px;
        border: 1px solid #e6e6e6;
      }

      .file__list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        margin: 0;
        padding: 0;

        > li {
          list-style: none;
          width: calc(100% - 10px);
          min-height: 40px;
          margin: 5px;
          display: flex;
          position: relative;
          border-bottom: 1px solid #e6e6e6;


          > .file__icon {
            text-align: center;

            .icon {
              width: 30px;
              height: 30px;
              vertical-align: -0.15em;
              fill: currentColor;
              overflow: hidden;
              margin-right: 10px;
              margin-top: 5px;
            }
          }

          > .file__info {
            width: calc(100% - 40px);
            display: flex;
            flex-direction: column;

            > .file__info-name {
              line-height: 20px;
              color: #495060;
              font-size: 13px;
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-wrap: break-word;
            }

            > .file__info-bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;

              > .file__info-size {
                height: 20px;
                line-height: 20px;
                font-size: 11px;
                color: #909399;
              }

              .file__info-handle {
                display: flex;
                align-items: center;

              }
            }
          }
        }
      }

      .CodeMirror-line  {

        span {
          color: #333333;
        }
        .cm-mark-user {
          color: #1b9aee;
          background-color: #e9f5fe;
        }
      }

      .reply-container {
        background-color: #F4F4FA;
        padding: 10px;
        display: flex;
        width: 100%;
        cursor: pointer;

        .line {
          width: 3px;
          height: 14px;
          background-color: #909399;
          margin-right: 10px;
        }

        .reply-content {
          font-size: 13px;
          width: calc(100% - 20px);
          color: #909399;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }
      }

      .ql-editor {
        height: 180px;
        background-color: #fff;
      }

      .handle {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;

        >div {
          display: flex;
          align-items: center;

          .el-button--text {
            i {
              font-size: 20px;
            }
          }

          .el-button--success {
            height: 30px;
            padding: 0 15px;
          }
        }
      }

      .cm-mark-user {
        color: #1b9aee;
        background-color: #e9f5fe;
      }
    }
  }
</style>
